import { render, staticRenderFns } from "./ErpDataDialog.vue?vue&type=template&id=1dcbb459&"
import script from "./ErpDataDialog.vue?vue&type=script&lang=js&"
export * from "./ErpDataDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports